import React, { Component } from "react";
import ReactGA from "react-ga";
import { DropTarget, DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import styles from "./Input.css";
import { playChar } from "../../../../sounds";
import { hasClientFeature } from "../../../../helpers/client";
import { DND_KEY } from "../../../../constants";

const dropTarget = {
  drop: (props, monitor) => {
    const { setValue, move } = props;

    const { char } = monitor.getItem();

    setValue(char);
    move();

    ReactGA.event({
      category: "Input type",
      action: "DnD"
    });
  },
  canDrop: props => !props.correct
};

const dragSource = {
  beginDrag: props => ({ char: props.value.toUpperCase() }),
  canDrag: props => Boolean(props.value) && !props.correct,
  endDrag: props => props.setValue("")
};

const dragCollect = connect => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview()
});

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  canDrop: monitor.canDrop(),
  isOver: monitor.isOver()
});

@DragSource(DND_KEY, dragSource, dragCollect)
@DropTarget(DND_KEY, dropTarget, dropCollect)
export default class Input extends Component {
  inputEl = null;

  componentDidMount = () => {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  };

  componentDidUpdate = prevProps => {
    if (!this.props.isOver && this.props.focused && !prevProps.focused) {
      // Focus input
      this.focus();
    }
    if (this.props.canDrop && this.props.isOver && !prevProps.isOver) {
      // On enter
      this.props.setFocus();
    }
    if (this.props.canDrop && !this.props.isOver && prevProps.isOver) {
      // On leave
      this.props.setFocus(false);
    }
  };

  handleChange = e => {
    const char = e.target.value;

    this.props.setValue(char);

    if (this.props.hint) {
      playChar(char);
    }

    ReactGA.event({
      category: "Input Type",
      action: "Keyboard"
    });
  };

  handleKeyUp = e => this.props.move(e.keyCode);

  handleFocus = () => this.props.setFocus();

  handleBlur = () => this.props.setFocus(false);

  focus = () => {
    if (this.inputEl) {
      this.inputEl.select();
    }
  };

  render = () => {
    const {
      x,
      y,
      width,
      height,
      value,
      focused,
      connectDropTarget,
      connectDragSource
    } = this.props;

    const input = hasClientFeature("touchevents") ? (
      value
    ) : (
      <input
        type="text"
        maxLength={1}
        value={value}
        onChange={this.handleChange}
        onKeyUp={this.handleKeyUp}
        onFocus={this.handleFocus}
        ref={el => {
          this.inputEl = el;
        }}
        autoFocus={focused}
      />
    );

    return [
      <foreignObject x={x} y={y} width={width} height={height}>
        <div className={styles.input}>{input}</div>
      </foreignObject>,
      connectDragSource(
        connectDropTarget(
          <rect
            x={x}
            y={y}
            width={width}
            height={height}
            fill="transparent"
            onClick={this.handleFocus}
          />
        )
      )
    ];
  };
}



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/Char/Input.js